export const SET_SELECTED_STORE = 'SET_SELECTED_STORE';
export const GET_SELECTED_STORE = 'GET_SELECTED_STORE';
export const CLEAR_SELECTED_STORE = 'CLEAR_SELECTED_STORE';
